import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SystemSettingsService } from 'common/src/modules/system-settings';
import { EMPTY } from 'rxjs';
import { map, mergeMap, catchError, switchMap } from 'rxjs/operators';
import {
  LoadCountries,
  LoadCountriesSuccess,
  LoadUserQuickActions,
  LoadUserQuickActionsSuccess,
  LoadUserShortcuts,
  LoadUserShortcutsSuccess
} from '../actions/shared.actions';
import { HrmService } from '../../hrm/hrm.service';

@Injectable()
export class SharedEffects {

  loadCountries$ = createEffect(() => this.actions$.pipe(
    ofType(LoadCountries),
    mergeMap(() => this.systemSettingsService.getAvailableCountries()
      .pipe(
        map(response => (LoadCountriesSuccess({countries: response.data}))),
        catchError(() => EMPTY)
      ))
    )
  );

  // loadCategories$ = createEffect(() => this.actions$.pipe(
  //   ofType(LoadCategories),
  //   mergeMap(() => this.systemSettingsService.getAvailableCategories()
  //     .pipe(
  //       map(categories => (LoadCategoriesSuccess({categories}))),
  //       catchError(() => EMPTY)
  //     ))
  //   )
  // );

  loadShortcuts$ = createEffect(() => this.actions$.pipe(
    ofType(LoadUserShortcuts),
    switchMap(( props: {userId: number}) => this.hrmService.getUserModulesShortcuts(props.userId)),
    map(userShortcuts => (LoadUserShortcutsSuccess({ userShortcuts }))),
    catchError(() => EMPTY)
  ));

  loadQuickActions$ = createEffect(() => this.actions$.pipe(
    ofType(LoadUserQuickActions),
    switchMap(( props: {userId: number}) => this.hrmService.getUserModulesQuickActions(props.userId)),
    map(userQuickActions => (LoadUserQuickActionsSuccess({ userQuickActions }))),
    catchError(() => EMPTY)
  ));

  constructor(
    private actions$: Actions,
    private readonly systemSettingsService: SystemSettingsService,
    private readonly hrmService: HrmService,
  ) {}
}
